import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const NotificationPopup = styled.div`
	width: 39.5rem;
	height: auto;
	border-radius: var(--small-border-radius);
	font-size: var(--paragraph3-font-size);
	background: var(--modal-bg-3);
	box-shadow: var(--container-box-shadow);
`;
export const NoNotificationMessage = styled.span`
	text-align: center;
	border-bottom: 1px solid var(--border-color);
	padding: 3rem 0;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: var(--padding-1) var(--padding-3);
	font-size: var(--paragraph3-font-size);
`;

export const ViewAllNotificationsButtonCss = css`
	width: 100%;
	gap: unset !important;
`;

export const Content = styled.div`
	border-bottom: 1px solid var(--border-color);
	font-size: var(--paragraph3-font-size);
	padding: var(--padding-2) var(--padding-3);
	cursor: pointer;

	:hover {
		background-color: var(--table-active-color);
	}

	> div {
		display: flex;
		gap: 1.5rem;
	}
`;

export const BoxIcon = styled.div`
	background-color: ${(props) => props.bgColor};
	color: var(--color-white);
	border-radius: 50%;
	display: flex;
	padding: var(--padding-1);
	margin-right: var(--margin-1);
`;

export const LoadingRow = styled.div`
	display: block;
	border-bottom: 1px solid var(--border-color);
	font-size: var(--paragraph3-font-size);
	padding: 2rem;

	body[dir='rtl'] & {
		padding: 0 1.5rem 0 1rem;
	}
`;
